import {AssetListItemData} from "../../../asset/util/assetModels";
import {AppStateAccountData} from "../../account/accountTypes";
import {WalletType} from "../walletTypes";

const initialWalletContextValue = {
  account: null as null | AppStateAccountData,
  accountAssets: [] as AssetListItemData[],
  walletAccounts: [] as AppStateAccountData[],
  walletType: null as null | WalletType
};

const ACCOUNT_DATA_POLLING_INTERVAL = 30000;
const DEFAULT_DELAY_IN_FETCHING_ACCOUNT_DATA = 250;
const MAX_NUMBER_OF_ATTEMPTS_TO_FETCH_ACCOUNT_DATA = 15;

export {
  initialWalletContextValue,
  ACCOUNT_DATA_POLLING_INTERVAL,
  DEFAULT_DELAY_IN_FETCHING_ACCOUNT_DATA,
  MAX_NUMBER_OF_ATTEMPTS_TO_FETCH_ACCOUNT_DATA
};
